import { render, staticRenderFns } from "./MultipleViewItem.vue?vue&type=template&id=5f2d6ff3"
import script from "./MultipleViewItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./MultipleViewItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports